import React from 'react';
import {createRoot} from 'react-dom/client';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import RecyclingStoreTopListApp from "./RecyclingStoreTopListApp";
import {I18nextProvider} from "react-i18next";
import i18n from "@apps/Shared/translation/i18n";

const container = document.getElementById('js-recycling-store-top-list-app')!;

if (container) {
    const root = createRoot(container);
    const queryClient = new QueryClient();

    const hiddenHeroInput = document.querySelector('.js-recycling-store-top-list-block');
    const id = Number((hiddenHeroInput as HTMLInputElement).value);

    root.render(
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <RecyclingStoreTopListApp id={id}/>
            </QueryClientProvider>
        </I18nextProvider>
    );
}